import QuestionMarkIcon from '@mui/icons-material/QuestionMark'
import { Box, Button, IconButton, Modal, Paper } from '@mui/material'
import { useState } from 'react'
import { pallete } from '../../../theme'
import { TranslatableTypography } from '../widgets'

const stylePrefix = 'CompanionVotingHelp'

const style = {
  [`& .${stylePrefix}-wrapper`]: {
    display: 'inline',
    '& button:hover': {
      backgroundColor: pallete.headerColor
    },
    '& .MuiButtonBase-root': {
      background: pallete.headerColor,
      padding: '4px',
      marginLeft: '10px',
      '& .MuiSvgIcon-root': {
        color: pallete.paperColor,
        width: '20px',
        height: '20px'
      }
    }
  }
}

const modalStyle = {
  '&': {
    padding: '26px',
    [`& .${stylePrefix}-paper`]: {
      padding: '10px',
      marginTop: '80px',
      filter: `drop-shadow(0px 0px 3px ${pallete.headerBrightColor})`,
      [`& .${stylePrefix}-ok`]: {
        width: '100%',
        textAlign: 'right'
      }
    }
  }
}

export const VotingHelp = () => {
  const [open, setOpen] = useState(false)
  return (
      <Box sx={style} >
        <Box className={`${stylePrefix}-wrapper`}>
          <IconButton onClick={() => setOpen(true)}>
            <QuestionMarkIcon/>
          </IconButton>
        </Box>

        <Modal
          open={open}
          onClose={() => setOpen(false)}
          sx={modalStyle}
        >
          <Paper
            className={`${stylePrefix}-paper`}
            sx={{
            }}
          >
            <TranslatableTypography>
              voting-help
            </TranslatableTypography>
            <Box className={`${stylePrefix}-ok`}>
              <Button onClick={() => setOpen(false)}>
                ok
              </Button>
            </Box>
          </Paper>
        </Modal>
      </Box>
  )
}
